/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'disc-fill': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M16 8A8 8 0 110 8a8 8 0 0116 0m-6 0a2 2 0 10-4 0 2 2 0 004 0M4 8a4 4 0 014-4 .5.5 0 000-1 5 5 0 00-5 5 .5.5 0 001 0m9 0a.5.5 0 10-1 0 4 4 0 01-4 4 .5.5 0 000 1 5 5 0 005-5"/>',
    },
});
